import Enum from 'enum';

export default new Enum(['LOBBY', 'LOADING', 'ROOM', 'INVALID_ROOM_ID'], {
    ignoreCase: true,
});
